
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.53","height":"19.527"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Cnames","transform":"translate(-322.363 -213.237)"}},[_c('g',{attrs:{"id":"Group_25582","data-name":"Group 25582","transform":"translate(322.366 213.237)"}},[_c('g',{attrs:{"id":"Group_25753","data-name":"Group 25753","fill":"none","stroke":"#5a677d","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_20294","data-name":"Path 20294","d":"M15.689 2.991A9.057 9.057 0 009.733.75a9.242 9.242 0 00-.97.05 8.67 8.67 0 00-.878.14l-.161.039a9.042 9.042 0 00-4.46 2.494q-.169.174-.333.36A9.05 9.05 0 0016.2 16.12c.114-.116.224-.235.332-.358a9.061 9.061 0 00-.843-12.771z"}}),_c('line',{attrs:{"id":"Line_421","data-name":"Line 421","x2":"18.215","transform":"translate(.607 9.921)"}}),_c('line',{attrs:{"id":"Line_422","data-name":"Line 422","y2":"18.479","transform":"translate(9.714 .681)"}}),_c('path',{attrs:{"id":"Path_20295","data-name":"Path 20295","d":"M14.627 9.763c0-4.978-2.2-9.013-4.914-9.013S4.8 4.785 4.8 9.763s2.2 9.013 4.913 9.013 4.914-4.035 4.914-9.013z"}}),_c('path',{attrs:{"id":"Path_20296","data-name":"Path 20296","d":"M16.66 3.89a15.634 15.634 0 01-6.946 1.433 15.731 15.731 0 01-6.892-1.4"}}),_c('path',{attrs:{"id":"Path_20297","data-name":"Path 20297","d":"M2.93 15.7a15.881 15.881 0 016.784-1.35 15.619 15.619 0 016.966 1.443"}})])])])])
          )
        }
      }
    